const backgroundAudioInteractionType = {
    START: 'start',
    PAUSE: 'pause',
    RESUME: 'resume',
    REPLAY: 'replay',
};

export default backgroundAudioInteractionType;
